import { LoanDashboardEntry } from '@src/components/LoanList/loan-filters-schema'
import { apiClient } from '@src/services/http-common'
import { useQuery } from '@tanstack/react-query'

const fifteenMinutes = 900000
const EMPTY_ARRAY: LoanDashboardEntry[] = []
const SCOPE = 'loanDashboardEntries'
const getLoanDashboardEntries = async (searchUrl: URLSearchParams): Promise<LoanDashboardEntry[]> => {
  const url = `LoanDashboardEntries?${searchUrl.toString()}`
  const response = await apiClient.get<LoanDashboardEntry[]>(url)
  return response.data
}

export function useGetLoanDashboardEntries(searchUrl: URLSearchParams): [LoanDashboardEntry[], boolean] {
  const key = searchUrl.toString()
  const { isFetching, data } = useQuery({
    queryKey: [SCOPE, { key }, searchUrl],
    queryFn: () => getLoanDashboardEntries(searchUrl),
    staleTime: fifteenMinutes,
    gcTime: fifteenMinutes,
  })

  return [data ?? EMPTY_ARRAY, isFetching]
}
